import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SahisSirketiPage from "../pages/sahis-sirketi/page";
import LimitedSirketPage from "../pages/limited-sirket/page";
import VergiDanismanligiPage from "../pages/vergi-danismanligi/page";
import GenelMuhasebePage from "../pages/genel-muhasebe/page";
import SgkBordroPage from "../pages/sgk-bordro/page";
import EFaturaPage from "../pages/e-fatura/page";
import BeyannameHizmetleriPage from "../pages/beyanname/page";
import MaliAnalizPage from "../pages/mali-analiz/page";
import TesvikDanismanligiPage from "../pages/tesvik/page";
import SirketTuruSecimPage from "../pages/sirket-turu/page";
import SahisSirketiNasilKurulurPage from "../pages/sahis-sirketi-nasil-kurulur/page";
import SahisSirketiVergiOranlariPage from "../pages/sahis-sirketi-vergi-oranlari/page";
import LimitedMiSahisMiPage from "../pages/limited-mi-sahis-mi/page";
import EFaturaKimlerIcinZorunluPage from "../pages/e-fatura-kimler-icin-zorunlu/page";
import VergiLevhasiNasilAlinirPage from "../pages/vergi-levhasi-nasil-alinir/page";
import BagkurPrimiNeKadarPage from "../pages/bagkur-primi-ne-kadar/page";
import KdvNedirNasilHesaplanirPage from "../pages/kdv-nedir-nasil-hesaplanir/page";
import VergiBorcuSorgulamaPage from "../pages/vergi-borcu-sorgulama/page";
import SirketKapatmaNasilYapilirPage from "../pages/sirket-kapatma-nasil-yapilir/page";
import MuhasebecDegistirmePage from "../pages/muhasebeci-degistirme/page";
import BlogPage from "../pages/blog/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/sahis-sirketi-kurulusu", element: <SahisSirketiPage /> },
  { path: "/limited-sirket-kurulusu", element: <LimitedSirketPage /> },
  { path: "/vergi-danismanligi", element: <VergiDanismanligiPage /> },
  { path: "/genel-muhasebe", element: <GenelMuhasebePage /> },
  { path: "/sgk-bordro", element: <SgkBordroPage /> },
  { path: "/e-fatura-e-arsiv", element: <EFaturaPage /> },
  { path: "/beyanname-hizmetleri", element: <BeyannameHizmetleriPage /> },
  { path: "/mali-analiz", element: <MaliAnalizPage /> },
  { path: "/tesvik-danismanligi", element: <TesvikDanismanligiPage /> },
  { path: "/sirket-turu-secimi", element: <SirketTuruSecimPage /> },
  { path: "/sahis-sirketi-nasil-kurulur", element: <SahisSirketiNasilKurulurPage /> },
  { path: "/sahis-sirketi-vergi-oranlari", element: <SahisSirketiVergiOranlariPage /> },
  { path: "/limited-mi-sahis-mi", element: <LimitedMiSahisMiPage /> },
  { path: "/e-fatura-kimler-icin-zorunlu", element: <EFaturaKimlerIcinZorunluPage /> },
  { path: "/vergi-levhasi-nasil-alinir", element: <VergiLevhasiNasilAlinirPage /> },
  { path: "/bagkur-primi-ne-kadar", element: <BagkurPrimiNeKadarPage /> },
  { path: "/kdv-nedir-nasil-hesaplanir", element: <KdvNedirNasilHesaplanirPage /> },
  { path: "/vergi-borcu-sorgulama", element: <VergiBorcuSorgulamaPage /> },
  { path: "/sirket-kapatma-nasil-yapilir", element: <SirketKapatmaNasilYapilirPage /> },
  { path: "/muhasebeci-degistirme", element: <MuhasebecDegistirmePage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
